var render, staticRenderFns
import script from "./cell-wrapper.vue?vue&type=script&lang=js"
export * from "./cell-wrapper.vue?vue&type=script&lang=js"
import style0 from "./cell-wrapper.vue?vue&type=style&index=0&id=72b26696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b26696",
  null
  
)

export default component.exports